import Intercom from '@intercom/messenger-js-sdk';
import { config } from './config.js';

export const INTERCOM_APP_ID = 'bthz75ch';

/**
 * Determines whether Intercom is allowed on the given server, based on its `allowIntercom` flag in config.js.
 *
 * @param {string} appName - The server's project ID.
 * @returns {boolean} True if Intercom is allowed on the server.
 */
export function isIntercomAllowed(appName) {
  return config?.firebaseConfigs?.[appName]?.allowIntercom === true;
}

/**
 * Calls a method on the global Intercom instance when available.
 *
 * @param {string} method - Intercom method name.
 * @param {...any} args - Arguments passed to the Intercom method.
 * @returns {void}
 */
function callIntercomMethod(method, ...args) {
  if (typeof window === 'undefined' || typeof window.Intercom !== 'function') return;

  window.Intercom(method, ...args);

  if (method === 'boot') {
    console.log('Booted Intercom with settings:', args[0]);
  }
}

/**
 * Initializes the Intercom messenger.
 *
 * @param {string} appName - Current application name.
 * @returns {void}
 */
export function initIntercom(appName) {
  if (isIntercomAllowed(appName)) {
    Intercom({
      app_id: INTERCOM_APP_ID
    });

    console.log('Intercom initialized');
  }
}

/**
 * Boots Intercom with the provided settings.
 *
 * @param {Record<string, unknown>} settings - Intercom boot settings.
 * @returns {void}
 */
export function bootIntercom(settings) {
  callIntercomMethod('boot', settings);
}

/**
 * Shuts down the current Intercom session.
 *
 * @returns {void}
 */
export function shutdownIntercom() {
  callIntercomMethod('shutdown');
}
